module.exports = __webpack_public_path__ + "static/media/Goeslim-Regular.652b13e0.otf";